<script>
import i18n from "../i18n";
import Notifications from "./horizontal-topbar/Notifications";
import AgentsOnline from "./horizontal-topbar/AgentsOnline";
import SelectTimezoneModal from "./horizontal-topbar/SelectTimezoneModal";
import SettingsModal from "./horizontal-topbar/SettingsModal.vue";
import UnassignedTickets from "./horizontal-topbar/UnassignedTickets";
import axios from 'axios';
import simplebar from "simplebar-vue";
import {layoutComputed} from "@/state/helpers";

/**
 * Horizontal-topbar component
 */
export default {
  props: {
    type: {
      type: String,
      required: true,
    },
    width: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...layoutComputed,
  },
  components: {
    simplebar,
    Notifications,
    AgentsOnline,
    SelectTimezoneModal,
    SettingsModal,
    UnassignedTickets
  },
  data() {
    return {
      determiningIfIAmATravelConsultant: false,
      amIATravelConsultant: false,
      showTimezoneModal: false,
      showSettingsModal: false,
      globalSearchQuery: '',
      languages: [
        {
          flag: require("@/assets/images/flags/uk.jpg"),
          language: "en",
          title: "English",
        },
        {
          flag: require("@/assets/images/flags/french.jpg"),
          language: "fr",
          title: "French",
        },
        {
          flag: require("@/assets/images/flags/spain.jpg"),
          language: "es",
          title: "spanish",
        },
        {
          flag: require("@/assets/images/flags/chaina.png"),
          language: "zh",
          title: "Chinese",
        },
        {
          flag: require("@/assets/images/flags/arabic.png"),
          language: "ar",
          title: "Arabic",
        },
      ],
      current_language: i18n.locale,
      text: null,
      flag: null,
      value: null,
    };
  },
  created() {
    this.determineIfIAmATravelConsultant();
  },
  mounted() {
    this.value = this.languages.find((x) => x.language === i18n.locale);
    this.text = this.value.title;
    this.flag = this.value.flag;
  },
  methods: {
    determineIfIAmATravelConsultant() {
      let vm = this;

      if (window.amIATravelConsultant) {
        vm.amIATravelConsultant = window.amIATravelConsultant;
        return;
      }

      vm.determiningIfIAmATravelConsultant = true;
      axios.get(API_BASE + '/users/current-user/am-i-a-travel-consultant').then(r => {
        vm.determiningIfIAmATravelConsultant = false;
        vm.amIATravelConsultant = Boolean(r.data);
        window.amIATravelConsultant = vm.amIATravelConsultant;
      }).catch(e => {
        console.log(e);
        vm.determiningIfIAmATravelConsultant = false;
        vm.amIATravelConsultant = false;
      });
    },

    searchGlobally() {
      this.$router.push('/tickets?q=' + encodeURIComponent(this.globalSearchQuery));
      this.globalSearchQuery = '';
    },
    logout() {
      this.$auth.logout();
    },
    toggleRightSidebar() {
      this.$parent.toggleRightSidebar();
    },
    toggleMenu() {
      let element = document.getElementById("topnav-menu-content");
      element.classList.toggle("show");
    },
    initFullScreen() {
      document.body.classList.toggle("fullscreen-enable");
      if (
          !document.fullscreenElement &&
          /* alternative standard method */ !document.mozFullScreenElement &&
          !document.webkitFullscreenElement
      ) {
        // current working methods
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen(
              Element.ALLOW_KEYBOARD_INPUT
          );
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    },
    setLanguage(locale, country, flag) {
      this.current_language = locale;
      this.text = country;
      this.flag = flag;
      i18n.locale = locale;
    },
    openSelectTimezoneModal() {
      this.showTimezoneModal = false;
      this.$nextTick(() => {
        this.showTimezoneModal = true;
        this.$nextTick(() => {
          this.$bvModal.show('select-timezone-modal');
        })
      })
    },
    openSettingsModal() {
      this.showSettingsModal = false;
      this.$nextTick(() => {
        this.showSettingsModal = true;
        this.$nextTick(() => {
          this.$bvModal.show('settings-modal');
        })
      })
    }
  },
  watch: {
    type: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          switch (newVal) {
            case "dark":
              document.body.setAttribute("data-topbar", "dark");
              document.body.removeAttribute("data-layout-scrollable");
              break;
            case "light":
              document.body.setAttribute("data-topbar", "light");
              document.body.removeAttribute("data-layout-size", "boxed");
              document.body.removeAttribute("data-layout-scrollable");
              break;
            case "colored":
              document.body.setAttribute("data-topbar", "colored");
              document.body.removeAttribute("data-layout-size", "boxed");
              break;
            default:
              document.body.setAttribute("data-topbar", "dark");
              break;
          }
        }
      },
    },
    width: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          switch (newVal) {
            case "boxed":
              document.body.setAttribute("data-layout-size", "boxed");
              break;
            case "fluid":
              document.body.setAttribute("data-layout-mode", "fluid");
              document.body.removeAttribute("data-layout-size");
              break;
            case "scrollable":
              document.body.setAttribute("data-layout-scrollable", "true");
              document.body.removeAttribute("data-layout-mode");
              document.body.removeAttribute("data-layout-size");
              break;
            default:
              document.body.setAttribute("data-layout-mode", "fluid");
              break;
          }
        }
      },
    },
  },
};
</script>

<template>
  <header id="page-topbar">
    <div class="navbar-header">
      <div class="d-flex">
        <!-- LOGO -->
        <div class="navbar-brand-box">
          <router-link to="/" class="logo logo-dark">
            <span class="logo-sm">
              <img src="@/assets/images/enhanceable-logo.png" alt height="22"/>
            </span>
            <span class="logo-lg">
              <img src="@/assets/images/enhanceable-logo.png" alt height="17"/>
            </span>
          </router-link>

          <router-link to="/" class="logo logo-light">
            <span class="logo-sm">
<!--              <img src="@/assets/images/logo-inside-asia.png" alt height="22"/>-->
              <img src="@/assets/images/White_Logo.png" alt height="40"/>
            </span>
            <span class="logo-lg">
              <img src="@/assets/images/White_Logo.png" alt height="40"/>
            </span>
          </router-link>
        </div>
        <button
            id="toggle"
            type="button"
            class="btn btn-sm mr-2 font-size-16 d-lg-none header-item"
            @click="toggleMenu"
        >
          <i class="fa fa-fw fa-bars"></i>
        </button>

        <!-- App Search-->
        <form class="app-search d-none d-lg-block" @submit.prevent="e => e.preventDefault()">
          <div class="position-relative">
            <input @keyup.enter.prevent="searchGlobally"
                   v-model="globalSearchQuery"
                   name="q" type="text" class="form-control" placeholder="Search..."/>
            <span class="bx bx-search-alt"></span>
          </div>
        </form>

        <router-link tag="button" type="button" to="/" class="ml-3 btn header-item">
          Dashboard
        </router-link>

        <router-link v-if="amIATravelConsultant" tag="button" type="button" to="/my-tc" class="ml-3 btn header-item">
          MyTC
        </router-link>

        <!-- <router-link tag="button" type="button" to="/tickets" class="ml-3 btn header-item">
          All Tickets
        </router-link>

        <router-link tag="button" type="button" to="/tickets/create" class="ml-3 btn header-item">
          Create New Ticket
        </router-link> -->

        <b-dropdown class="ml-3" variant="black" toggle-class="header-item">
          <template v-slot:button-content>
            <span class="mr-1">
              Tickets
            </span>
            <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
          </template>
          <b-dropdown-item @click.prevent="$router.push('/tickets')">
            <router-link tag="span" to="/tickets">
              <i class="bx bx-search-alt font-size-16 align-middle mr-1"></i>
              All tickets
            </router-link>
          </b-dropdown-item>
          <b-dropdown-item @click.prevent="$router.push('/tickets/unassigned')">
            <router-link tag="span" to="/tickets/unassigned">
              <i class="bx bx-search-alt font-size-16 align-middle mr-1"></i>
              Unassigned tickets
            </router-link>
          </b-dropdown-item>
          <b-dropdown-item @click.prevent="$router.push('/incident-reports')">
            <router-link tag="span" to="/incident-reports">
              <i class="bx bx-file font-size-16 align-middle mr-1"></i>
              Incident reports
            </router-link>
          </b-dropdown-item>
          <b-dropdown-item @click.prevent="$router.push('/tickets/create')">
            <router-link tag="span" to="/tickets/create">
              <i class="bx bx-plus font-size-16 align-middle mr-1"></i>
              Create ticket
            </router-link>
          </b-dropdown-item>
        </b-dropdown>

<!--        <b-dropdown class="ml-3" variant="black" toggle-class="header-item">-->
<!--          <template v-slot:button-content>-->
<!--            <span class="mr-1">-->
<!--              SLAs-->
<!--            </span>-->
<!--            <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>-->
<!--          </template>-->
<!--          <b-dropdown-item @click.prevent="$router.push('/sla-breaches')">-->
<!--            <router-link tag="span" to="/sla-breaches">-->
<!--              <i class="bx bx-search-alt font-size-16 align-middle mr-1"></i>-->
<!--              All SLA breaches-->
<!--            </router-link>-->
<!--          </b-dropdown-item>-->
<!--        </b-dropdown>-->

        <b-dropdown class="ml-3" variant="black" toggle-class="header-item">
          <template v-slot:button-content>
            <span class="mr-1">
              Reporting
            </span>
            <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
          </template>
          <b-dropdown-item @click.prevent="$router.push('/reporting')">
            <router-link tag="span" to="/reporting">
              <i class="bx bx-search-alt font-size-16 align-middle mr-1"></i>
              All reports
            </router-link>
          </b-dropdown-item>
          <b-dropdown-item @click.prevent="$router.push('/reporting/create')">
            <router-link tag="span" to="/reporting/create">
              <i class="bx bx-plus font-size-16 align-middle mr-1"></i>
              Create report
            </router-link>
          </b-dropdown-item>
          <b-dropdown-item @click.prevent="$router.push('/automated-reporting')">
            <router-link tag="span" to="/automated-reporting">
              <i class="bx bx-search-alt font-size-16 align-middle mr-1"></i>
              All automated reports
            </router-link>
          </b-dropdown-item>
          <b-dropdown-item @click.prevent="$router.push('/automated-reporting/create')">
            <router-link tag="span" to="/automated-reporting/create">
              <i class="bx bx-plus font-size-16 align-middle mr-1"></i>
              Create automated report
            </router-link>
          </b-dropdown-item>
        </b-dropdown>

        <b-dropdown class="ml-2" variant="black" toggle-class="header-item">
          <template v-slot:button-content>
            <span class="mr-1">
              Settings
            </span>
            <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
          </template>
          <b-dropdown-item @click.prevent="$router.push('/settings/ticket-templates')">
            <router-link tag="span" to="/settings/ticket-templates">
              <i class="bx bx-note font-size-16 align-middle mr-1"></i>
              Ticket Templates
            </router-link>
          </b-dropdown-item>
          <b-dropdown-item @click.prevent="$router.push('/settings/ticket-note-templates')">
            <router-link tag="span" to="/settings/ticket-note-templates">
              <i class="bx bx-note font-size-16 align-middle mr-1"></i>
              Note Templates
            </router-link>
          </b-dropdown-item>
          <b-dropdown-item @click.prevent="$router.push('/settings/ticket-email-templates')">
            <router-link tag="span" to="/settings/ticket-email-templates">
              <i class="bx bx-note font-size-16 align-middle mr-1"></i>
              Email Templates
            </router-link>
          </b-dropdown-item>
          <b-dropdown-item @click.prevent="$router.push('/settings/ticket-whatsapp-templates')">
            <router-link tag="span" to="/settings/ticket-whatsapp-templates">
              <i class="bx bx-note font-size-16 align-middle mr-1"></i>
              WhatsApp Templates
            </router-link>
          </b-dropdown-item>
          <b-dropdown-item @click.prevent="$router.push('/settings/tag-templates')">
            <router-link tag="span" to="/settings/tag-templates">
              <i class="bx bx-note font-size-16 align-middle mr-1"></i>
              Tag Templates
            </router-link>
          </b-dropdown-item>
          <b-dropdown-item @click.prevent="$router.push('/settings/slas')">
            <router-link tag="span" to="/settings/slas">
              <i class="bx bx-note font-size-16 align-middle mr-1"></i>
              SLAs
            </router-link>
          </b-dropdown-item>
          <b-dropdown-item @click.prevent="$router.push('/settings/autoresponder')">
            <router-link tag="span" to="/settings/autoresponder">
              <i class="bx bx-mail-send font-size-16 align-middle mr-1"></i>
              Autoresponder
            </router-link>
          </b-dropdown-item>
          <b-dropdown-item @click.prevent="$router.push('/settings/twilio-phone-numbers')">
            <router-link tag="span" to="/settings/twilio-phone-numbers">
              <i class="bx bx-phone font-size-16 align-middle mr-1"></i>
              Phone Numbers
            </router-link>
          </b-dropdown-item>
          <b-dropdown-item @click.prevent="$router.push('/settings/users')">
            <router-link tag="span" to="/settings/users">
              <i class="bx bx-user font-size-16 align-middle mr-1"></i>
              Users
            </router-link>
          </b-dropdown-item>
          <b-dropdown-item @click.prevent="$router.push('/settings/offices')">
            <router-link tag="span" to="/settings/offices">
              <i class="bx bx-user font-size-16 align-middle mr-1"></i>
              Offices
            </router-link>
          </b-dropdown-item>
        </b-dropdown>

        <!--                <b-dropdown-->
        <!--                        variant="black"-->
        <!--                        class="dropdown-mega d-none d-lg-block ml-2"-->
        <!--                        toggle-class="header-item"-->
        <!--                        menu-class="dropdown-megamenu"-->
        <!--                >-->
        <!--                    <template v-slot:button-content>-->
        <!--                        {{ $t("navbar.dropdown.megamenu.text") }}-->
        <!--                        <i class="mdi mdi-chevron-down"></i>-->
        <!--                    </template>-->

        <!--                    <div class="row">-->
        <!--                        <div class="col-sm-8">-->
        <!--                            <div class="row">-->
        <!--                                <div class="col-md-4">-->
        <!--                                    <h5 class="font-size-14 mt-0">-->
        <!--                                        {{ $t("navbar.dropdown.megamenu.uicontent.title") }}-->
        <!--                                    </h5>-->
        <!--                                    <ul class="list-unstyled megamenu-list">-->
        <!--                                        <li>-->
        <!--                                            <a href="javascript:void(0);">{{-->
        <!--                                                $t("navbar.dropdown.megamenu.uicontent.list.lightbox")-->
        <!--                                                }}</a>-->
        <!--                                        </li>-->
        <!--                                        <li>-->
        <!--                                            <a href="javascript:void(0);">{{-->
        <!--                                                $t(-->
        <!--                                                "navbar.dropdown.megamenu.uicontent.list.rangeslider"-->
        <!--                                                )-->
        <!--                                                }}</a>-->
        <!--                                        </li>-->
        <!--                                        <li>-->
        <!--                                            <a href="javascript:void(0);">{{-->
        <!--                                                $t("navbar.dropdown.megamenu.uicontent.list.sweetalert")-->
        <!--                                                }}</a>-->
        <!--                                        </li>-->
        <!--                                        <li>-->
        <!--                                            <a href="javascript:void(0);">{{-->
        <!--                                                $t("navbar.dropdown.megamenu.uicontent.list.rating")-->
        <!--                                                }}</a>-->
        <!--                                        </li>-->
        <!--                                        <li>-->
        <!--                                            <a href="javascript:void(0);">{{-->
        <!--                                                $t("navbar.dropdown.megamenu.uicontent.list.forms")-->
        <!--                                                }}</a>-->
        <!--                                        </li>-->
        <!--                                        <li>-->
        <!--                                            <a href="javascript:void(0);">{{-->
        <!--                                                $t("navbar.dropdown.megamenu.uicontent.list.tables")-->
        <!--                                                }}</a>-->
        <!--                                        </li>-->
        <!--                                        <li>-->
        <!--                                            <a href="javascript:void(0);">{{-->
        <!--                                                $t("navbar.dropdown.megamenu.uicontent.list.charts")-->
        <!--                                                }}</a>-->
        <!--                                        </li>-->
        <!--                                    </ul>-->
        <!--                                </div>-->

        <!--                                <div class="col-md-4">-->
        <!--                                    <h5 class="font-size-14 mt-0">-->
        <!--                                        {{ $t("navbar.dropdown.megamenu.application.title") }}-->
        <!--                                    </h5>-->
        <!--                                    <ul class="list-unstyled megamenu-list">-->
        <!--                                        <li>-->
        <!--                                            <a href="javascript:void(0);">{{-->
        <!--                                                $t(-->
        <!--                                                "navbar.dropdown.megamenu.application.list.ecommerce"-->
        <!--                                                )-->
        <!--                                                }}</a>-->
        <!--                                        </li>-->
        <!--                                        <li>-->
        <!--                                            <a href="javascript:void(0);">{{-->
        <!--                                                $t("navbar.dropdown.megamenu.application.list.calendar")-->
        <!--                                                }}</a>-->
        <!--                                        </li>-->
        <!--                                        <li>-->
        <!--                                            <a href="javascript:void(0);">{{-->
        <!--                                                $t("navbar.dropdown.megamenu.application.list.email")-->
        <!--                                                }}</a>-->
        <!--                                        </li>-->
        <!--                                        <li>-->
        <!--                                            <a href="javascript:void(0);">{{-->
        <!--                                                $t("navbar.dropdown.megamenu.application.list.projects")-->
        <!--                                                }}</a>-->
        <!--                                        </li>-->
        <!--                                        <li>-->
        <!--                                            <a href="javascript:void(0);">{{-->
        <!--                                                $t("navbar.dropdown.megamenu.application.list.tasks")-->
        <!--                                                }}</a>-->
        <!--                                        </li>-->
        <!--                                        <li>-->
        <!--                                            <a href="javascript:void(0);">{{-->
        <!--                                                $t("navbar.dropdown.megamenu.application.list.contacts")-->
        <!--                                                }}</a>-->
        <!--                                        </li>-->
        <!--                                    </ul>-->
        <!--                                </div>-->

        <!--                                <div class="col-md-4">-->
        <!--                                    <h5 class="font-size-14 mt-0">-->
        <!--                                        {{ $t("navbar.dropdown.megamenu.extrapages.title") }}-->
        <!--                                    </h5>-->
        <!--                                    <ul class="list-unstyled megamenu-list">-->
        <!--                                        <li>-->
        <!--                                            <a href="javascript:void(0);">{{-->
        <!--                                                $t(-->
        <!--                                                "navbar.dropdown.megamenu.extrapages.list.lightsidebar"-->
        <!--                                                )-->
        <!--                                                }}</a>-->
        <!--                                        </li>-->
        <!--                                        <li>-->
        <!--                                            <a href="javascript:void(0);">{{-->
        <!--                                                $t(-->
        <!--                                                "navbar.dropdown.megamenu.extrapages.list.compactsidebar"-->
        <!--                                                )-->
        <!--                                                }}</a>-->
        <!--                                        </li>-->
        <!--                                        <li>-->
        <!--                                            <a href="javascript:void(0);">{{-->
        <!--                                                $t(-->
        <!--                                                "navbar.dropdown.megamenu.extrapages.list.horizontallayout"-->
        <!--                                                )-->
        <!--                                                }}</a>-->
        <!--                                        </li>-->
        <!--                                        <li>-->
        <!--                                            <a href="javascript:void(0);">{{-->
        <!--                                                $t(-->
        <!--                                                "navbar.dropdown.megamenu.extrapages.list.maintenance"-->
        <!--                                                )-->
        <!--                                                }}</a>-->
        <!--                                        </li>-->
        <!--                                        <li>-->
        <!--                                            <a href="javascript:void(0);">{{-->
        <!--                                                $t(-->
        <!--                                                "navbar.dropdown.megamenu.extrapages.list.comingsoon"-->
        <!--                                                )-->
        <!--                                                }}</a>-->
        <!--                                        </li>-->
        <!--                                        <li>-->
        <!--                                            <a href="javascript:void(0);">{{-->
        <!--                                                $t("navbar.dropdown.megamenu.extrapages.list.timeline")-->
        <!--                                                }}</a>-->
        <!--                                        </li>-->
        <!--                                        <li>-->
        <!--                                            <a href="javascript:void(0);">{{-->
        <!--                                                $t("navbar.dropdown.megamenu.extrapages.list.faqs")-->
        <!--                                                }}</a>-->
        <!--                                        </li>-->
        <!--                                    </ul>-->
        <!--                                </div>-->
        <!--                            </div>-->
        <!--                        </div>-->
        <!--                        <div class="col-sm-4">-->
        <!--                            <div class="row">-->
        <!--                                <div class="col-sm-6">-->
        <!--                                    <h5 class="font-size-14 mt-0">-->
        <!--                                        {{ $t("navbar.dropdown.megamenu.uicontent.title") }}-->
        <!--                                    </h5>-->
        <!--                                    <ul class="list-unstyled megamenu-list">-->
        <!--                                        <li>-->
        <!--                                            <a href="javascript:void(0);">{{-->
        <!--                                                $t("navbar.dropdown.megamenu.uicontent.list.lightbox")-->
        <!--                                                }}</a>-->
        <!--                                        </li>-->
        <!--                                        <li>-->
        <!--                                            <a href="javascript:void(0);">{{-->
        <!--                                                $t(-->
        <!--                                                "navbar.dropdown.megamenu.uicontent.list.rangeslider"-->
        <!--                                                )-->
        <!--                                                }}</a>-->
        <!--                                        </li>-->
        <!--                                        <li>-->
        <!--                                            <a href="javascript:void(0);">{{-->
        <!--                                                $t("navbar.dropdown.megamenu.uicontent.list.sweetalert")-->
        <!--                                                }}</a>-->
        <!--                                        </li>-->
        <!--                                        <li>-->
        <!--                                            <a href="javascript:void(0);">{{-->
        <!--                                                $t("navbar.dropdown.megamenu.uicontent.list.rating")-->
        <!--                                                }}</a>-->
        <!--                                        </li>-->
        <!--                                        <li>-->
        <!--                                            <a href="javascript:void(0);">{{-->
        <!--                                                $t("navbar.dropdown.megamenu.uicontent.list.forms")-->
        <!--                                                }}</a>-->
        <!--                                        </li>-->
        <!--                                        <li>-->
        <!--                                            <a href="javascript:void(0);">{{-->
        <!--                                                $t("navbar.dropdown.megamenu.uicontent.list.tables")-->
        <!--                                                }}</a>-->
        <!--                                        </li>-->
        <!--                                        <li>-->
        <!--                                            <a href="javascript:void(0);">{{-->
        <!--                                                $t("navbar.dropdown.megamenu.uicontent.list.charts")-->
        <!--                                                }}</a>-->
        <!--                                        </li>-->
        <!--                                    </ul>-->
        <!--                                </div>-->

        <!--                                <div class="col-sm-5">-->
        <!--                                    <div>-->
        <!--                                        <img-->
        <!--                                                src="@/assets/images/megamenu-img.png"-->
        <!--                                                alt-->
        <!--                                                class="img-fluid mx-auto d-block"-->
        <!--                                        />-->
        <!--                                    </div>-->
        <!--                                </div>-->
        <!--                            </div>-->
        <!--                        </div>-->
        <!--                    </div>-->
        <!--                </b-dropdown>-->
      </div>

      <div class="d-flex">
        <b-dropdown
            class="d-inline-block d-lg-none ml-2"
            variant="black"
            menu-class="dropdown-menu-lg p-0"
            toggle-class="header-item noti-icon"
            right
        >
          <template v-slot:button-content>
            <i class="mdi mdi-magnify"></i>
          </template>

          <form class="p-3">
            <div class="form-group m-0">
              <div class="input-group">
                <input
                    type="text"
                    class="form-control"
                    placeholder="Search ..."
                    aria-label="Recipient's username"
                />
                <div class="input-group-append">
                  <button class="btn btn-primary" type="submit">
                    <i class="mdi mdi-magnify"></i>
                  </button>
                </div>
              </div>
            </div>
          </form>
        </b-dropdown>
        <!--        <b-dropdown variant="white" right toggle-class="header-item">-->
        <!--          <template v-slot:button-content>-->
        <!--            <img class :src="flag" alt="Header Language" height="16" />-->
        <!--            {{ text }}-->
        <!--          </template>-->
        <!--          <b-dropdown-item-->
        <!--            class="notify-item"-->
        <!--            v-for="(entry, i) in languages"-->
        <!--            :key="`Lang${i}`"-->
        <!--            :value="entry"-->
        <!--            @click="setLanguage(entry.language, entry.title, entry.flag)"-->
        <!--            :class="{ active: current_language === entry.language }"-->
        <!--          >-->
        <!--            <img-->
        <!--              :src="`${entry.flag}`"-->
        <!--              alt="user-image"-->
        <!--              class="mr-1"-->
        <!--              height="12"-->
        <!--            />-->
        <!--            <span class="align-middle">{{ entry.title }}</span>-->
        <!--          </b-dropdown-item>-->
        <!--        </b-dropdown>-->

        <!--        <b-dropdown-->
        <!--          class="d-none d-lg-inline-block noti-icon"-->
        <!--          menu-class="dropdown-menu-lg"-->
        <!--          right-->
        <!--          toggle-class="header-item"-->
        <!--          variant="black"-->
        <!--        >-->
        <!--          <template v-slot:button-content>-->
        <!--            <i class="bx bx-customize"></i>-->
        <!--          </template>-->

        <!--          <div class="px-lg-2">-->
        <!--            <div class="row no-gutters">-->
        <!--              <div class="col">-->
        <!--                <a class="dropdown-icon-item" href="javascript: void(0);">-->
        <!--                  <img src="@/assets/images/brands/github.png" alt="Github" />-->
        <!--                  <span>{{ $t("navbar.dropdown.site.list.github") }}</span>-->
        <!--                </a>-->
        <!--              </div>-->
        <!--              <div class="col">-->
        <!--                <a class="dropdown-icon-item" href="javascript: void(0);">-->
        <!--                  <img-->
        <!--                    src="@/assets/images/brands/bitbucket.png"-->
        <!--                    alt="bitbucket"-->
        <!--                  />-->
        <!--                  <span>{{ $t("navbar.dropdown.site.list.github") }}</span>-->
        <!--                </a>-->
        <!--              </div>-->
        <!--              <div class="col">-->
        <!--                <a class="dropdown-icon-item" href="javascript: void(0);">-->
        <!--                  <img-->
        <!--                    src="@/assets/images/brands/dribbble.png"-->
        <!--                    alt="dribbble"-->
        <!--                  />-->
        <!--                  <span>{{ $t("navbar.dropdown.site.list.dribbble") }}</span>-->
        <!--                </a>-->
        <!--              </div>-->
        <!--            </div>-->

        <!--            <div class="row no-gutters">-->
        <!--              <div class="col">-->
        <!--                <a class="dropdown-icon-item" href="javascript: void(0);">-->
        <!--                  <img src="@/assets/images/brands/dropbox.png" alt="dropbox" />-->
        <!--                  <span>{{ $t("navbar.dropdown.site.list.dropbox") }}</span>-->
        <!--                </a>-->
        <!--              </div>-->
        <!--              <div class="col">-->
        <!--                <a class="dropdown-icon-item" href="javascript: void(0);">-->
        <!--                  <img-->
        <!--                    src="@/assets/images/brands/mail_chimp.png"-->
        <!--                    alt="mail_chimp"-->
        <!--                  />-->
        <!--                  <span>{{ $t("navbar.dropdown.site.list.mailchimp") }}</span>-->
        <!--                </a>-->
        <!--              </div>-->
        <!--              <div class="col">-->
        <!--                <a class="dropdown-icon-item" href="javascript: void(0);">-->
        <!--                  <img src="@/assets/images/brands/slack.png" alt="slack" />-->
        <!--                  <span>{{ $t("navbar.dropdown.site.list.slack") }}</span>-->
        <!--                </a>-->
        <!--              </div>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--        </b-dropdown>-->

        <UnassignedTickets></UnassignedTickets>
        <AgentsOnline></AgentsOnline>
        <select-timezone-modal v-if="showTimezoneModal"></select-timezone-modal>
        <settings-modal v-if="showSettingsModal"></settings-modal>

        <div class="dropdown d-none d-lg-inline-block ml-1">
          <button
              type="button"
              class="btn header-item noti-icon"
              @click="initFullScreen"
          >
            <i class="bx bx-fullscreen"></i>
          </button>
        </div>

        <!-- Notifications -->
        <Notifications></Notifications>
        <!-- / Notifications -->

        <b-dropdown right variant="black" toggle-class="header-item">
          <template v-slot:button-content>
            <!--                        <img v-if="$auth.isAuthenticated"-->
            <!--                             class="rounded-circle header-profile-user"-->
            <!--                             :src="$auth.user.picture"-->
            <!--                             alt="Header Avatar"-->
            <!--                        />-->
            <!--                        <img v-if="$auth.isAuthenticated"-->
            <!--                             class="rounded-circle header-profile-user"-->
            <!--                             src="@/assets/images/harvey.jpg"-->
            <!--                             alt="Header Avatar"-->
            <!--                        />-->

            <span class="d-none d-xl-inline-block ml-2" v-if="$auth.isAuthenticated">
              {{ $auth.user.name }}
            </span>
            <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
          </template>
          <!-- item-->
          <!--          <b-dropdown-item>-->
          <!--            <router-link tag="span" to="/contacts/profile">-->
          <!--              <i class="bx bx-user font-size-16 align-middle mr-1"></i>-->
          <!--              {{ $t("navbar.dropdown.henry.list.profile") }}-->
          <!--            </router-link>-->
          <!--          </b-dropdown-item>-->
          <!--          <b-dropdown-item href="javascript: void(0);">-->
          <!--            <i class="bx bx-wallet font-size-16 align-middle mr-1"></i>-->
          <!--            {{ $t("navbar.dropdown.henry.list.mywallet") }}-->
          <!--          </b-dropdown-item>-->
          <!--          <b-dropdown-item class="d-block" href="javascript: void(0);">-->
          <!--            <span class="badge badge-success float-right">11</span>-->
          <!--            <i class="bx bx-wrench font-size-16 align-middle mr-1"></i>-->
          <!--            {{ $t("navbar.dropdown.henry.list.settings") }}-->
          <!--          </b-dropdown-item>-->
          <!--          <b-dropdown-item href="javascript: void(0);">-->
          <!--            <i class="bx bx-lock-open font-size-16 align-middle mr-1"></i>-->
          <!--            {{ $t("navbar.dropdown.henry.list.lockscreen") }}-->
          <!--          </b-dropdown-item>-->
          <!--          <b-dropdown-divider></b-dropdown-divider>-->
          <b-dropdown-item @click.prevent="$router.push('/profile')">
            <router-link tag="span" to="/profile">
              <i class="bx bx-user font-size-16 align-middle mr-1"></i>
              Profile
            </router-link>
          </b-dropdown-item>
          <b-dropdown-item @click.prevent="$router.push('/whatsapp')">
            <router-link tag="span" to="/whatsapp">
              <i class="bx bx-phone font-size-16 align-middle mr-1"></i>
              WhatsApp
            </router-link>
          </b-dropdown-item>
          <li role="presentation">
            <a href="#" @click="openSelectTimezoneModal" class="dropdown-item">
              <i
                  class="bx bx-time-five font-size-16 align-middle mr-1"
              ></i>
              Timezone
            </a>
          </li>
          <li role="presentation">
            <a href="#" @click="openSettingsModal" class="dropdown-item">
              <i
                  class="bx bx-cog font-size-16 align-middle mr-1"
              ></i>
              Settings
            </a>
          </li>
          <li><hr class="dropdown-divider"></li>
          <li role="presentation">
            <span class="dropdown-item text-muted">
              <!-- <i class="bx bx-info-circle font-size-16 align-middle mr-1"></i> -->
              Version 2.1.0
            </span>
          </li>
          <li><hr class="dropdown-divider"></li>
          <li role="presentation">
            <a href="#" @click="logout" class="dropdown-item text-danger">
              <i
                  class="bx bx-power-off font-size-16 align-middle mr-1 text-danger"
              ></i>
              {{ $t("navbar.dropdown.henry.list.logout") }}
            </a>
          </li>
        </b-dropdown>
      </div>
    </div>
  </header>
</template>
